﻿export class RegistrationApiCommunicator {
    // registers with just a mailing address

    // registers with full name, email, phone

    // update lead with email

    // update lead with phone
} 